module.exports = __webpack_public_path__ + "images/133_1024.jpg";